import { createFileRoute } from '@tanstack/react-router'
import { SwapPage } from '@/features/trade/swap/SwapPage'

export const Route = createFileRoute('/_app/swap/')({
  component: SwapPage,
})
